import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Utensils } from 'lucide-react';

export const ChineseFoodFacts: React.FC = () => {
  const facts = [
    {
      title: "The Origin of Chopsticks",
      content: "Chopsticks were invented in China over 3,000 years ago! Initially used for cooking, they later became eating utensils during the Han Dynasty (206 BCE–220 CE). 🥢"
    },
    {
      title: "Tea Culture",
      content: "Chinese tea culture dates back over 5,000 years! Tea was originally used as medicine before becoming a daily beverage. Different regions developed unique tea varieties and ceremonies. 🍵"
    },
    {
      title: "The Dumpling Legacy",
      content: "Dumplings were invented by Zhang Zhongjing during the Han Dynasty to help people stay warm and prevent frostbite. He created a medicinal lamb soup with dumplings! 🥟"
    },
    {
      title: "Wok Cooking History",
      content: "The wok was invented over 2,000 years ago during the Han Dynasty. Its unique shape allows for even heat distribution and requires less fuel for cooking! 🔥"
    },
    {
      title: "Imperial Cuisine",
      content: "Peking Duck was originally created for Chinese emperors during the Yuan Dynasty. The dish requires extensive preparation and specific cooking techniques passed down through generations! 👑"
    },
    {
      title: "Five Elements Philosophy",
      content: "Chinese cuisine follows the philosophy of Wu Xing (Five Elements), balancing flavors of salty, bitter, sour, sweet, and umami in dishes to promote health and harmony! 🌿"
    },
    {
      title: "Noodle Innovation",
      content: "The world's oldest known noodles were discovered in China, dating back 4,000 years! They were made from millet, showing the long history of Chinese culinary innovation! 🍜"
    },
    {
      title: "Regional Diversity",
      content: "Chinese cuisine has eight major regional traditions, each with distinct flavors and cooking methods. This diversity reflects China's vast geography and cultural heritage! 🗺️"
    }
  ];

  return (
    <>
      <Helmet>
        <title>Amazing Chinese Food Facts & Trivia | Chinese Food Maps</title>
        <meta name="description" content="Discover fascinating facts about Chinese cuisine! From ancient cooking techniques to modern culinary traditions, explore the rich history and culture behind Chinese food." />
        <meta property="og:title" content="Amazing Chinese Food Facts & Trivia | Chinese Food Maps" />
        <meta property="og:description" content="Discover fascinating facts about Chinese cuisine! From ancient cooking techniques to modern culinary traditions." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://chinesefoodmaps.com/chinese-food-facts" />
        <meta property="og:image" content="https://cdn-icons-png.flaticon.com/512/2548/2548242.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Amazing Chinese Food Facts & Trivia | Chinese Food Maps" />
        <meta name="twitter:description" content="Discover fascinating facts about Chinese cuisine!" />
        <meta name="twitter:image" content="https://cdn-icons-png.flaticon.com/512/2548/2548242.png" />
        <link rel="canonical" href="https://chinesefoodmaps.com/chinese-food-facts" />
      </Helmet>
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold mb-6 text-red-900">🥢 Fascinating Chinese Food Facts</h1>
        
        <div className="grid gap-6 md:grid-cols-2">
          {facts.map((fact, index) => (
            <div 
              key={index}
              className="bg-white rounded-lg shadow-md p-6 border-l-4 border-red-700 hover:shadow-lg transition-shadow"
            >
              <div className="flex items-start gap-4">
                <Utensils className="text-red-700 flex-shrink-0 mt-1" size={24} />
                <div>
                  <h2 className="text-xl font-semibold mb-2 text-gray-800">{fact.title}</h2>
                  <p className="text-gray-600">{fact.content}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};